import messages from '@codesyntax/volto-listingadvanced-variation/messages';

export const AgendaSchema = (props) => {
  const { intl, schema, formData } = props;
  const headingChoices = [
    ['h2', 'H2'],
    ['h3', 'H3'],
    ['h4', 'H4'],
  ];
  return {
    ...schema,
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['variation'],
      },
      {
        id: 'querystring',
        title: intl.formatMessage(messages.querystring),
        fields: ['querystring'],
      },
      {
        id: 'header',
        title: intl.formatMessage(messages.headerConfiguration),
        fields: ['header', 'headerUrl', 'headerTag'],
      },
      {
        id: 'moreLink',
        title: intl.formatMessage(messages.moreLinkConfiguration),
        fields: ['moreLinkText', 'moreLinkUrl'],
      },
    ],
    properties: {
      ...schema.properties,
      header: {
        title: intl.formatMessage(messages.header),
        description: intl.formatMessage(messages.headerDescription),
      },
      headerUrl: {
        title: intl.formatMessage(messages.headerUrl),
        description: intl.formatMessage(messages.headerUrlDescription),
        widget: 'object_browser',
        mode: 'link',
        allowExternals: true,
      },
      headerTag: {
        title: intl.formatMessage(messages.headerTag),
        description: intl.formatMessage(messages.headerTagDescription),
        choices: [['h1', 'H1'], ...headingChoices],
      },
      moreLinkText: {
        title: intl.formatMessage(messages.moreLinkText),
        description: intl.formatMessage(messages.moreLinkTextDescription),
      },
      moreLinkUrl: {
        title: intl.formatMessage(messages.moreLinkUrl),
        description: intl.formatMessage(messages.moreLinkUrlDescription),
        widget: 'object_browser',
        mode: 'link',
        allowExternals: true,
      },
    },
  };
};
